
















import Vue from "vue";

export const Blob = Vue.extend({
  name: "Blob",
  props: { path: String, BaseHue: String, interval: Number },
  data: () => ({ blobStyle: {}, transition: "" }),
  created() {
    // initial position
    // this.blobStyle = this.getRandomBlobPosition();
    this.updateBlobStyle();
    setInterval(this.updateBlobStyle, this.interval * 1000);
  },
  mounted() {
    this.updateBlobStyle();
  },
  methods: {
    getTransitionInterval() {
      return Math.round(10 + Math.random() * 20);
    },
    updateBlobStyle() {
      const newBlobStyle = this.getRandomBlobPosition();

      this.blobStyle = {
        ...newBlobStyle,
        transition: `all ${this.interval}s linear`,
      };
    },
    getRandomBlobPosition() {
      // top/left position of
      // const top = `${50 + Math.round(Math.random() * 30)}%`;
      // const left = `${-10 + Math.round(Math.random() * 120)}%`;
      const posX = Math.random() < 0.5;
      const posY = Math.random() < 0.5;
      const x = Math.round(Math.random() * 10);
      const left = posX ? `-${x}%` : `${100 + x}%`;
      const y = Math.round(Math.random() * 10);
      const top = posY ? `-${y}%` : `${100 + y}%`;
      const transform = `scale(${Math.random() * 2})`;
      return { left, top, transform };
    },
  },
});

export default Blob;
